module.exports = __webpack_public_path__ + "img/vn_vn - 副本.e75b0cf5.png";